import { Stack } from '@mui/material'
import { styled } from '@mui/material/styles'
import { EmptyFilesImage, tokens } from 'ComponentLibrary'
import { Typography } from 'ComponentLibrary/src/piazza'

export const PdfViewerContainer = styled(Stack)(() => ({
    width: '100%',
    position: 'relative',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: tokens.SizingSpacing150,
    padding: tokens.SizingSpacing150,
    boxSizing: 'border-box',
    overflow: 'visible',
    '& .react-pdf__Page__textContent': {
        pointerEvents: 'auto !important',
        userSelect: 'text',
    },
    '& .react-pdf__Page__textContent span': {
        cursor: 'text',
    },
}))

export const HeaderBar = styled('div')(() => ({
    width: '100%',
    paddingBottom: tokens.SizingSpacing100,
    marginBottom: tokens.SizingSpacing150,
    borderBottom: `${tokens.SizingBorderS} solid ${tokens.ColorBorderDefault}`,
}))

export const NavControls = styled(Stack)(() => ({
    minWidth: 'fit-content',
}))

export const SearchInfo = styled(Typography)(() => ({
    marginTop: -tokens.SizingSpacing050,
}))

export const DocumentWrapper = styled('div')(() => ({
    width: '100%',
}))

export const SearchHighlightOverlay = styled('div')(() => ({
    position: 'absolute',
    inset: 0,
    pointerEvents: 'none',
    zIndex: 5,
}))

export const FocusHighlightOverlay = styled(SearchHighlightOverlay)(() => ({
    zIndex: 6,
}))

export const SearchHighlightRect = styled('span')(() => ({
    position: 'absolute',
    borderRadius: tokens.SizingCornerS,
    backgroundColor: 'rgba(255, 235, 59, 0.45)',
}))

export const FocusHighlightRect = styled('span')(() => ({
    position: 'absolute',
    borderRadius: tokens.SizingCornerS,
    backgroundColor: 'rgba(255, 152, 0, 0.32)',
    transform: 'translateY(3px)',
}))

export const EmptyPdfStateCard = styled(Stack)(() => ({
    width: '532px',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    boxSizing: 'border-box',
    padding: tokens.SizingSpacing300,
    borderRadius: tokens.SizingCornerM,
    backgroundColor: tokens.ColorSurfaceDefault,
    backgroundImage:
        "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' rx='12' ry='12' fill='none' stroke='%23E6EAF0' stroke-width='2' stroke-dasharray='2%2c 8' stroke-linecap='round'/%3e%3c/svg%3e\")",
}))

export const EmptyPdfStateContent = styled(Stack)(() => ({
    maxWidth: '380px',
    alignItems: 'center',
    textAlign: 'center',
    padding: tokens.SizingSpacing200,
    gap: tokens.SizingSpacing150,
}))

export const EmptyPdfStateIllustration = styled(EmptyFilesImage)(() => ({
    width: '270px',
    height: '270px',
}))
